// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-css {
  display: block;
  font-size: 16px;
  font-family: sans-serif;
  font-weight: 700;
  color: #444;
  line-height: 1.3;
  padding: 0.6em 1.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.5em;
  appearance: none;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #888;
}
.select-css:focus {
  border-color: #aaa;
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}
.select-css option {
  font-weight: normal;
}

.custom-col-5-5 {
  width: 45%; /* 5.5/12 = 45% */
  float: left;
}

.custom-col-6-5 {
  width: 55%; /* 6.5/12 = 55% */
  float: left;
}

@media (max-width: 844px) {
  .click_btn {
    display: grid;
    justify-content: center;
    margin-top: 3rem;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Harvest/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,2CAA2C;EAC3C,oBAAoB;EAGpB,gBAAgB;EAChB,sBAAsB;EACtB;wDACsD;EACtD,oCAAoC;EACpC,6CAA6C;EAC7C,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,wCAAwC;EACxC,WAAW;EACX,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU,EAAE,iBAAiB;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU,EAAE,iBAAiB;EAC7B,WAAW;AACb;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":[".select-css {\n  display: block;\n  font-size: 16px;\n  font-family: sans-serif;\n  font-weight: 700;\n  color: #444;\n  line-height: 1.3;\n  padding: 0.6em 1.4em 0.5em 0.8em;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  border: 1px solid #aaa;\n  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);\n  border-radius: 0.5em;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\"),\n    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);\n  background-repeat: no-repeat, repeat;\n  background-position: right 0.7em top 50%, 0 0;\n  background-size: 0.65em auto, 100%;\n}\n.select-css::-ms-expand {\n  display: none;\n}\n.select-css:hover {\n  border-color: #888;\n}\n.select-css:focus {\n  border-color: #aaa;\n  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);\n  box-shadow: 0 0 0 3px -moz-mac-focusring;\n  color: #222;\n  outline: none;\n}\n.select-css option {\n  font-weight: normal;\n}\n\n.custom-col-5-5 {\n  width: 45%; /* 5.5/12 = 45% */\n  float: left;\n}\n\n.custom-col-6-5 {\n  width: 55%; /* 6.5/12 = 55% */\n  float: left;\n}\n\n@media (max-width: 844px) {\n  .click_btn {\n    display: grid;\n    justify-content: center;\n    margin-top: 3rem;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
